import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionHeadingProps {
    eyebrow: string
    title: ReactNode
    description?: ReactNode
    align?: 'left' | 'center'
    className?: string
}

const SectionHeading: FC<SectionHeadingProps> = ({ eyebrow, title, description, align = 'left', className }): ReactNode => {
    const centered = align === 'center'

    return (
        <div className={cn('max-w-3xl', centered && 'mx-auto text-center', className)}>
            <p className={cn('flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.3em] text-gold', centered && 'justify-center')}>
                <span className='h-px w-8 bg-gold/70' aria-hidden='true' />
                {eyebrow}
            </p>
            <h2 className='mt-6 font-heading text-[clamp(1.6rem,3.4vw,2.9rem)] font-bold leading-[1.08] tracking-[0.01em] text-white'>
                {title}
            </h2>
            {description && (
                <p className='mt-6 text-base leading-relaxed text-titanium-light sm:text-lg'>
                    {description}
                </p>
            )}
        </div>
    )
}

export default SectionHeading
